import React, { Component } from 'react'
import injectSheet from 'react-jss'
import { sheet } from './sheet'
import { Classes } from 'jss'
import LogoMenu from 'components/svgComponent/LogoMenu'
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'

type Props = RouteComponentProps & {
  classes: Classes
}

class Privacy extends Component<Props> {
  render() {
    const { classes, history } = this.props

    return (
      <div className={classes.main}>
        <div className={classes.navBar}>
          <LogoMenu onClick={() => history.push('/')} />
        </div>

        <div className={classes.root}>
          <h1>Privacy Policy for Skilent</h1>
          <p>
            Skilent (“we”, “our”, “us”) respects your privacy and is committed to protecting your
            personal data. This Privacy Policy explains what information we collect, how we use it,
            how we share it, and your rights.
          </p>

          <h3>Effective Date</h3>
          <p>{new Date('2025-05-01').toISOString().split('T')[0]}</p>

          <h3>Information We Collect</h3>
          <ul>
            <li>
              <strong>Account Information:</strong> email address, password, and optional profile
              data (e.g., name).
            </li>
            <li>
              <strong>Profile & Documents:</strong> resumes/CVs, certifications, and other
              attachments you upload.
            </li>
            <li>
              <strong>Usage & Diagnostics:</strong> basic analytics (app interactions) and crash/
              performance logs to improve reliability.
            </li>
            <li>
              <strong>Device/Technical Data:</strong> device type, OS version, and similar standard
              telemetry necessary for app functionality and security.
            </li>
          </ul>

          <h3>How We Use Your Information</h3>
          <ul>
            <li>To provide secure authentication and account management.</li>
            <li>To deliver core app features (e.g., job search, profile management).</li>
            <li>To personalize and improve our services and user experience.</li>
            <li>To communicate important updates (service notices, security alerts).</li>
            <li>To maintain security, prevent fraud, and ensure legal compliance.</li>
          </ul>

          <h3>Legal Bases (where applicable)</h3>
          <ul>
            <li>Performance of a contract (providing the services you request).</li>
            <li>Legitimate interests (service improvement, security).</li>
            <li>Consent, where we rely on it (you can withdraw it at any time).</li>
            <li>Compliance with legal obligations.</li>
          </ul>

          <h3>Data Sharing</h3>
          <p>
            We do <strong>not sell</strong> your personal data. We may share data with trusted
            service providers (e.g., cloud hosting, email delivery, error monitoring) solely to
            operate and support our services, under appropriate confidentiality and security
            obligations. We may disclose information if required by law or to protect our rights,
            users, or the public.
          </p>

          <h3>Security</h3>
          <ul>
            <li>Data in transit is protected with HTTPS/TLS.</li>
            <li>Passwords are stored using industry‑standard hashing.</li>
            <li>Access to personal data is restricted to authorized personnel only.</li>
          </ul>

          <h3>Data Retention</h3>
          <p>
            We retain personal data only for as long as necessary to provide the service and meet
            legal or operational requirements. If you request deletion, we remove your account data
            and related content, and we may retain minimal records required by law or for legitimate
            business purposes for up to <strong>90 days</strong> before permanent deletion.
          </p>

          <h3>Your Rights</h3>
          <ul>
            <li>Access, update, or correct your information.</li>
            <li>Request deletion of your account and associated data.</li>
            <li>Object to or restrict certain processing, where applicable.</li>
            <li>Withdraw consent where processing relies on consent.</li>
          </ul>

          <h3>Delete Account & Data</h3>
          <p>
            You can request deletion at any time by following the steps on our{' '}
            <a href="/account/how-to-delete">Delete Account &amp; Data Removal</a> page or by
            emailing <a href="mailto:support@skilent.com">support@skilent.com</a>.
          </p>

          <h3>Children’s Privacy</h3>
          <p>
            Our services are not directed to children under 13, and we do not knowingly collect
            personal information from children under 13.
          </p>

          <h3>International Transfers</h3>
          <p>
            Your data may be processed in countries other than your country of residence. We take
            steps to ensure appropriate safeguards are in place consistent with applicable law.
          </p>

          <h3>Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. We will post the latest version on
            this page and update the effective date above.
          </p>

          <h3>Contact Us</h3>
          <p>
            If you have questions about this Privacy Policy or your data, contact us at{' '}
            <a href="mailto:support@skilent.com">support@skilent.com</a>.
          </p>

          <p style={{ opacity: 0.7, marginTop: 24 }}>
            Last updated: {new Date().toISOString().split('T')[0]}
          </p>
        </div>
      </div>
    )
  }
}

export default withRouter(injectSheet(sheet)(Privacy))
